export default "__VITE_ASSET__CXaB_FzP__";